import {Form} from "../../form/form";
import {GvfUiService} from "../../../../gvf/js/gvf-ui-service";
import {GvfService} from "../../../../gvf/js/gvf-service";

export class ReportDashboardWorkerForm extends Form{
    refreshReportResults(){
        if(!this.$reportResults){
            const $container = $("<div />").addClass("form-group").insertAfter(this.$tablesField);
            this.$reportResults = $("<div />").css({"overflow":"auto","max-height":"300px","margin-right":"20px","border":"1px solid #ddd","padding":"0 5px"});
            $container.append("<label class='control-label'>"+GvfService.lang("Selecciona el contenido a mostrar")+"</label>");
            $container.append(this.$reportResults);
        }

        if(this.$tablesField.formFieldVal()){
            this.$reportResults.html("Cargando informe...");
            GvfService.endpoint(
                "/cp/stat-report-detail/get-report",
                {data:{"content.tables":this.$tablesField.formFieldVal()},isEditing:true}
            ).then(
                (resp)=>{
                    this.$reportResults.html(resp.html);
                    GvfUiService.init(this.$reportResults);
                    this.$reportResults.find("[data-dashboard-anchor]").addClass("is-selectable");
                    this.$reportResults.find(".is-selectable").hover(
                        (ev)=>{
                            $(ev.currentTarget).addClass("is-selected");
                        },
                        (ev)=>{
                            $(ev.currentTarget).removeClass("is-selected");
                        }
                    ).click(
                        (ev)=>{
                            ev.stopPropagation();
                            ev.preventDefault();
                            this.$reportResults.find(".is-selected-current").removeClass("is-selected-current");
                            $(ev.currentTarget).addClass("is-selected is-selected-current");
                            this.$anchorField.val($(ev.currentTarget).data("dashboard-anchor"));
                        }
                    ).children().css("pointer-events","none");

                    //initial load
                    const initialAnchor = this.$anchorField.val();
                    if(initialAnchor){
                        this.$reportResults.find("[data-dashboard-anchor="+initialAnchor+"]").addClass("is-selected is-selected-current");
                    }
                }
            );
        }else{
            this.$reportResults.html("");
        }
    }

    ready(){
        super.ready();
        this.$anchorField = this.$root.find("[name=anchor]");
        this.$tablesField = this.$root.findFormFieldByName("tables");
        this.$reportResults = null;
        this.$tablesField.on(
            "formField:changeVal",
            ()=>{
                //reset extract field
                this.$anchorField.val("");
                this.refreshReportResults();
            }
        );
        this.refreshReportResults();
    }
}

